import { useContext, useEffect, useRef, useState } from 'react'
// import { faVolumeHigh, faVolumeLow, faVolumeXmark } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Image, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import {
    faThumbsDown as regularThumbsDown,
    faThumbsUp as regularThumbsUp
} from '@fortawesome/free-regular-svg-icons';
import '../AudioFiles/audioplayer.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AudioPlayerContext } from '../AudioFiles/AudioPlayerContext';

function MiniPlayer() {
    const seekStep = 10; // seconds to seek forward or backward
    const nextTrackBtn = useRef(null)
    const previousTrackBtn = useRef(null)
    const audioPlayerRef = useRef(null)
    const [disablenext, setNextButtonDisable] = useState(false)
    const [disableprev, setPreButtonDisable] = useState(true)
    const [language, setLanguage] = useState(0)
    const {
        setTrack,
        currentTrack,
        isPlaying,
        pauseTrack,
        playTrack,
        duration,
        currentTime,
        seekTo,
        audioRef,
        episodeThumb,
        currentEpisodeNumber,
        totalEpisodeCount,
        audioTracks,
        // currentTrackLanguage,
        closePlayer,
    } = useContext(AudioPlayerContext);
    const [error, setError] = useState(false);
    const [isDisliked, setIsDisliked] = useState(false);
    const [isLiked, setIsLiked] = useState(false)
    const [likeCount, setLikeCount] = useState(0)
    // const [volume, setVolume] = useState(localStorage.getItem('dastaan__player_volume') != null ? localStorage.getItem('dastaan__player_volume') : 1);
    const [playbackRate, setPlaybackRate] = useState(localStorage.getItem('dastaan__player_speed') != null ? localStorage.getItem('dastaan__player_speed') : 1);
    const path_name = window.location.pathname
    const segments = path_name.split('/');
    const [value, setValue] = useState(0); // current time in seconds
    // const [total_time, setTotalTime] = useState(0); // current time in seconds
    const route = segments[1]
    let id = 0;
    const dw = window.innerWidth
    const navigate = useNavigate()
    if (route === 'audio-file-detail') {
        id = segments[2]
    }
    useEffect(() => {
        if (currentEpisodeNumber > 1) {
            setPreButtonDisable(false)
        }
        setValue(0); // Reset seekbar manually when currentTrack changes
    }, [currentTrack]);
    /* seekbar progress and pause on end */
    useEffect(() => {
        const audio = audioRef.current;
        const updateSeekbar = () => {
            setValue(audio.currentTime);
        };
        const handleEnded = () => {
            pauseTrack(true);
        };
        audio.addEventListener('timeupdate', updateSeekbar);
        audio.addEventListener('ended', handleEnded);
        return () => {
            audio.removeEventListener('timeupdate', updateSeekbar);
            audio.removeEventListener('ended', handleEnded);
        };
    }, []);
    useEffect(() => {
        const audio = audioRef.current;
        if (audioTracks.length === parseInt(currentTrack + 1))
            setNextButtonDisable(true)
        if (currentTrack === 0)
            setPreButtonDisable(false)
        // console.log(disablenext,disableprev);
        const handleAudioError = () => {
            setError(true);
        };
        audio.addEventListener('error', handleAudioError);
        return () => {
            audio.removeEventListener('error', handleAudioError);
        };
    }, [audioRef]);
    useEffect(() => {
        if (id > 0) {
            getAudioFileDetails()
        }
    }, [])
    const handleSeek = (e) => {
        const newTime = (e.target.value / 100) * duration;
        // console.log(duration,newTime);
        seekTo(newTime);
        setValue(newTime)
        console.log(newTime);
    };
    if (error) {
        return toast.error('Failed to load audio')
    }
    const handleForward = () => {
        const newTime = currentTime + seekStep;
        seekTo(newTime);
    };
    const handleRewind = () => {
        const newTime = currentTime - seekStep;
        seekTo(newTime);
    };
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    };
    const handleVolumeChange = (e) => {
        const newVolume = e.target.value;
        // setVolume(newVolume);
        audioRef.current.volume = newVolume;
        localStorage.setItem('dastaan__player_volume', newVolume);
        // console.log(parseInt(newVolume * 100));
    };
    const handleSpeedChange = (e) => {
        const newPlaybackRate = e.target.value;
        setPlaybackRate(newPlaybackRate);
        audioRef.current.playbackRate = newPlaybackRate;
        localStorage.setItem('dastaan__player_speed', newPlaybackRate);
    };
    //handleLanguage
    const handleLanguage = (e) => {
        const language_id = e.target.value;
        setLanguage(language_id)
        // console.log(language_id);
        // playTrack(audioTracks, currentEpisodeNumber, currentEpisodeNumber - 1, episodeThumb, currentTime || 0, language_id)
        playTrack(audioTracks, currentEpisodeNumber, currentEpisodeNumber - 1, episodeThumb, 0, language_id)
        // setTrackLanguage(language_id)
        // setPlaybackRate(newPlaybackRate);
        // audioRef.current.playbackRate = newPlaybackRate;
    };
    const handleNextTrack = () => {
        // console.info('Handle Next track');
        // console.log(totalEpisodeCount);
        setPreButtonDisable(false)
        previousTrackBtn.current.classList.remove('not-allowed')
        setTrack(currentEpisodeNumber + 1, currentEpisodeNumber, language)
        if (totalEpisodeCount === currentEpisodeNumber + 1) {
            // console.log('Next button is disabled...');
            nextTrackBtn.current.classList.add('not-allowed')
            setNextButtonDisable(true)
        }
    }
    const handlePreviousTrack = () => {
        setTrack(currentEpisodeNumber - 1, currentEpisodeNumber - 2, language)
        nextTrackBtn.current.classList.remove('not-allowed')
        setNextButtonDisable(false)
        if ((currentEpisodeNumber - 1) === 1) {
            // console.log('Previos button is disabled...');
            previousTrackBtn.current.classList.add('not-allowed')
            setPreButtonDisable(true)
        }
    }
    const getAudioFileDetails = async () => {
        try {
            const data = JSON.stringify({
                'user_id': localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : 1,
                audio_file_id: id
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/audio-file-detail`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config).then((response) => {
                const resData = response.data.Podcast_App;
                const audio_file_detail = resData.audio_file_data;
                const pS = localStorage.getItem('dastaan__plan_active');
                if (pS !== resData.user_plan_status) {
                    localStorage.removeItem('dastaan__plan_active');
                    localStorage.setItem('dastaan__plan_active', resData.user_plan_status);
                }
                setLikeCount(audio_file_detail?.likes)
                setIsLiked(audio_file_detail.isliked !== null ? (audio_file_detail.isliked === 1 ? true : false) : false)
                setIsDisliked(audio_file_detail.isliked !== null ? (audio_file_detail.isliked === 1 ? false : true) : false)
            })
        } catch (error) {
        }
    }
    const handleLikeDislike = async () => {
        // e.stopPropagation(); // Prevent bubbling if needed
        let is_disliked = false;
        let is_liked = false;
        let audio_file_id = id;
        try {
            if (isLiked === false) {
                setIsLiked(true)
                setIsDisliked(false)
                is_disliked = false;
                is_liked = true;
                // toast('Disliked');
            }
            else if (isLiked === true) {
                setIsLiked(false)
                setIsDisliked(true)
                is_disliked = true;
                is_liked = false
                // toast('Liked');
            }
            const data = {
                "user_id": localStorage.getItem('dastaan__user_id'), // integer
                audio_file_id,//integer
                is_liked,
                is_disliked //boolean
            };
            const config = {
                method: 'POST',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/add-remove-likes`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            await axios(config).then((response) => {
                //window.location.reload()
                setLikeCount(response?.data?.Podcast_App?.data?.likes)
            });
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <>
            <Col md={3} sm={2} xs={2} onClick={() => route !== 'audio-file-detail' ? navigate(`/audio-file-detail/${localStorage.getItem('audio_file_id')}`) : ''}>
                <img src={episodeThumb} alt={currentTrack.title} className="thumbnail" />
            </Col>
            <Col md={3} sm={2} xs={3} className='mt-1 text-white player-episode-title-info' onClick={() => route !== 'audio-file-detail' ? navigate(`/audio-file-detail/${localStorage.getItem('audio_file_id')}`) : ''}>
                <p >Episode {currentEpisodeNumber}/{totalEpisodeCount}
                    <br />
                    <small className="current-track">
                        {currentTrack.title?.split(' ').length > 2 ? (
                            <div className="marquee-wrapper">
                                <div className="marquee-text">{currentTrack.title}</div>
                            </div>
                        ) : (
                            currentTrack.title?.split(' ').slice(0, 10).join(' ')
                        )}
                    </small>
                </p>
            </Col>
            <Col md={6} sm={6} xs={7} className='audio-player-seekbar-controller'>
                <Row>
                    <Col md={10} xs={9}>
                        <Row className='controls'>
                            <Col md={4} xs={4}>
                                <Row>
                                    <Col md={6} sm={6} xs={6} onClick={handlePreviousTrack}>
                                        <button disabled={disableprev} ref={previousTrackBtn}
                                            className={`audio_player_btns_forward  ${disableprev === true ? 'not-allowed' : ''}`} >
                                            <Image className='previous-btn'
                                                src={`${process.env.PUBLIC_URL}/player_icons/${currentEpisodeNumber === 1 ? 'previous_disabled.svg' : 'previous.svg'}`}
                                            />
                                        </button>
                                    </Col>
                                    <Col md={6} sm={6} xs={6} onClick={handleRewind}>
                                        <button className='audio_player_btns__back' >
                                            <Image className='backward-btn'
                                                src={`${process.env.PUBLIC_URL}/player_icons/backward_btn.svg`}
                                            />
                                        </button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={4} xs={4} className='text-center'>
                                {isPlaying ? (
                                    <button className='audio_player_btns_play_pause' onClick={() => {pauseTrack(true)}}> <Image
                                            className='play-pause-btn'
                                            src={`${process.env.PUBLIC_URL}/player_icons/pause_btn.svg`}
                                        /></button>
                                ) : (
                                    <button className='audio_player_btns_play_pause'
                                        onClick={() => {
                                            pauseTrack(false)
                                        }}
                                    >
                                        <Image className='play-pause-btn'
                                            src={`${process.env.PUBLIC_URL}/player_icons/play_btn.svg`}
                                        />
                                    </button>
                                )}
                            </Col>
                            <Col md={4} xs={4} className='text-right'>
                                <Row>
                                    <Col md={6} sm={6} xs={6} onClick={handleForward}>
                                        <button className='audio_player_btns_forward' >
                                            <Image className='forward-btn'
                                                src={`${process.env.PUBLIC_URL}/player_icons/forward_btn.svg`}
                                            /></button>
                                    </Col>
                                    <Col md={6} sm={6} xs={6} onClick={handleNextTrack}>
                                        <button disabled={disablenext} ref={nextTrackBtn} className={`audio_player_btns_forward ${disablenext === true ? 'not-allowed' : ''}`} >
                                            <Image className='next-btn'
                                                src={`${process.env.PUBLIC_URL}/player_icons/${currentEpisodeNumber === totalEpisodeCount ? 'next_disabled.svg' : 'next.svg'}`}
                                            />
                                        </button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} xs={3} className='close-player-btn pointer'>
                        <span className='text-white' onClick={closePlayer}>
                            {/* <FontAwesomeIcon icon={faCircleXmark} /> */}
                            <Image className='close-btn'
                                src={`${process.env.PUBLIC_URL}/player_icons/close_player.svg`}
                            />
                        </span>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

export default MiniPlayer